const playBtns = document.querySelectorAll<HTMLElement>('.video-inline__play');
window._wq = window._wq || [];

playBtns.forEach((playBtn) => {
	playBtn.addEventListener('click', () => {
		const video = playBtn.parentElement?.querySelector<HTMLElement>('.video-inline');
		if (!video) return;

		video.classList.add('video-inline--is-visible');
		playBtn.style.display = 'none';

		const wistia = window.Wistia?.api(playBtn.getAttribute('data-wistia-id'));
		if (!wistia) return;

		wistia.play();
	});
});
